import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  useEffect(() => {
    document.title = '鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木';
    
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const recommendItems = [
    {
      image: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/121c685b6591c0bce480484388b43c70.jpeg',
      name: '新鮮な刺身',
      description: '産地直送の魚介を毎日仕入れ、いけじめ・神絞めで丁寧に処理しています',
    },
    {
      image: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/79d20a850aa3c3ca07881bb3b1205a14.webp',
      name: '秋田県産野菜',
      description: '地元秋田から届く新鮮な野菜を使った小皿料理をご用意',
    },
    {
      image: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/82ed58ac8454e0294110c64cd63e77c4.webp',
      name: '厳選日本酒',
      description: '季節ごとに変わる15種類以上の日本酒を100mlからお楽しみいただけます',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-screen">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-top"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/488814045f8b783dec919162c77b149d.webp"
            alt="さかなの木 新鮮な魚介料理"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="hero-copy absolute inset-0 flex items-end justify-start px-8 md:px-16 pb-20 md:pb-24">
            <div className="max-w-3xl text-left">
              <h2 className="text-3xl md:text-6xl font-bold mb-6 leading-tight text-white">
                鵜の木で味わう<br />産地直送の新鮮魚介
              </h2>
              <p className="text-base md:text-xl mb-8 text-white">
                地域に根ざし、毎日届く旬の恵みを小皿で楽しむ海鮮居酒屋
              </p>
              <a
                href="#contact"
                className="btn-primary inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full text-lg font-medium hover:bg-primary/90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <span>ご予約・お問い合わせ</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SEO H1 */}
      <h1 className="text-xs text-gray-400 text-center py-1 leading-none">鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* News Bar */}
      <div className="bg-beige border-b border-secondary/20">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <span className="px-4 py-1 bg-primary text-white text-sm font-bold rounded whitespace-nowrap">
              NEWS
            </span>
            <div className="flex-1 overflow-hidden">
              <div className="flex gap-8 animate-scroll">
                <Link to="/news" className="text-sm text-accent hover:text-primary transition-colors whitespace-nowrap">
                  <span className="text-gray-500">2024.01.15</span> 新春特別メニューのご案内
                </Link>
                <Link to="/news" className="text-sm text-accent hover:text-primary transition-colors whitespace-nowrap">
                  <span className="text-gray-500">2024.01.10</span> 1月の日本酒ラインナップ更新
                </Link>
                <Link to="/news" className="text-sm text-accent hover:text-primary transition-colors whitespace-nowrap">
                  <span className="text-gray-500">2024.01.05</span> テイクアウト弁当のご予約受付中
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Concept Section */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <span className="text-primary text-sm font-bold tracking-wider">CONCEPT</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#3A3D3F' }}>
              地域の拠り所となる場所を目指して
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div className="relative">
              <div className="absolute inset-0 border-4 rounded-lg transform translate-x-4 translate-y-4" style={{ borderColor: '#d4edeb' }}></div>
              <img
                src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/998cc9fdfc3e94f9198a40d52a19a6bf.webp"
                alt="店内の様子"
                className="relative rounded-lg w-full h-auto object-cover"
              />
            </div>
            <div>
              <p className="leading-relaxed mb-6" style={{ color: '#3A3D3F' }}>
                「さかなの木」は、地域密着を第一に考える海鮮居酒屋です。店名の「木」には、この地に根を張り、地域の皆様と共に成長していきたいという想いが込められています。
              </p>
              <p className="leading-relaxed mb-6" style={{ color: '#3A3D3F' }}>
                毎日産地直送で届く新鮮な魚介を、いけじめ・神経絞めで丁寧に処理。秋田県産の野菜と共に、小皿スタイルでお楽しみいただけます。
              </p>
              <p className="leading-relaxed mb-8" style={{ color: '#3A3D3F' }}>
                15種類以上の日本酒は季節ごとに変わり、100mlからお楽しみいただけるので、料理に合わせて様々なお酒をお試しいただけます。
              </p>
              <Link
                to="/concept"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary text-primary rounded-full font-medium hover:bg-primary hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                <span>詳しく見る</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Today's Recommend */}
      <section 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <span className="text-primary text-sm font-bold tracking-wider">OUR MENU</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#3A3D3F' }}>さかなの木のこだわり</h2>
            <p className="text-gray-600 mt-4">小皿スタイルで楽しむ、新鮮な魚介と秋田野菜</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {recommendItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3" style={{ color: '#39444C' }}>{item.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link
              to="/menu"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary text-white rounded-full font-medium hover:bg-primary/90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-md"
            >
              <span>メニューを見る</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 md:w-32 md:h-32 bg-gradient-to-br from-purple-400/20 to-pink-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 md:w-40 md:h-40 bg-gradient-to-br from-orange-400/20 to-pink-400/20 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              {/* Left Content */}
              <div>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6">
                  <i className="ri-instagram-line text-lg md:text-xl"></i>
                  <span>FOLLOW US</span>
                </div>
                <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-accent mb-3 md:mb-4">
                  毎日更新中！<br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                    @sakananoki_unoki
                  </span>
                </h2>
                <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6 leading-relaxed">
                  市場から仕入れた新鮮な魚介を使った本日のおすすめメニュー、季節の特別料理、店内の温かい雰囲気をInstagramで毎日お届けしています。
                </p>
                
                {/* Features */}
                <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                  <div className="flex items-start gap-2 md:gap-3">
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex-shrink-0">
                      <i className="ri-restaurant-line text-white text-lg md:text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-accent mb-0.5 md:mb-1 text-sm md:text-base">本日のおすすめメニュー</h3>
                      <p className="text-xs md:text-sm text-gray-600">新鮮な魚介を使った日替わりメニューを毎日投稿</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3">
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gradient-to-br from-orange-500 to-pink-500 rounded-lg flex-shrink-0">
                      <i className="ri-calendar-event-line text-white text-lg md:text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-accent mb-0.5 md:mb-1 text-sm md:text-base">季節のイベント情報</h3>
                      <p className="text-xs md:text-sm text-gray-600">特別メニューや地域イベントをいち早くお知らせ</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2 md:gap-3">
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-500 rounded-lg flex-shrink-0">
                      <i className="ri-image-line text-white text-lg md:text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-accent mb-0.5 md:mb-1 text-sm md:text-base">店内の様子</h3>
                      <p className="text-xs md:text-sm text-gray-600">温かみのある雰囲気とスタッフの日常をご紹介</p>
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <a
                  href="https://www.instagram.com/sakananoki_unoki/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-2 md:gap-3 px-6 py-3 md:px-8 md:py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 text-white rounded-full text-base md:text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer relative overflow-hidden"
                >
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-700 via-pink-700 to-orange-600 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  <i className="ri-instagram-line text-xl md:text-2xl relative z-10"></i>
                  <span className="relative z-10">フォローして最新情報をチェック</span>
                  <i className="ri-arrow-right-line text-lg md:text-xl relative z-10 group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>

              {/* Right Content - Instagram Preview */}
              <div className="relative mt-8 md:mt-0">
                {/* Instagram Frame */}
                <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl md:shadow-2xl p-4 md:p-6 transform hover:scale-105 transition-transform">
                  <blockquote 
                    className="instagram-media" 
                    data-instgrm-permalink="https://www.instagram.com/sakananoki_unoki/?utm_source=ig_embed&amp;utm_campaign=loading" 
                    data-instgrm-version="14"
                    style={{
                      background: '#FFF',
                      border: 0,
                      borderRadius: '12px',
                      boxShadow: 'none',
                      margin: '0 auto',
                      maxWidth: '540px',
                      minWidth: '280px',
                      padding: 0,
                      width: '100%'
                    }}
                  >
                  </blockquote>
                </div>
                
                {/* Floating Elements */}
                <div className="hidden md:flex absolute -top-6 -right-6 w-16 h-16 md:w-20 md:h-20 items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl shadow-lg transform rotate-12 animate-bounce">
                  <i className="ri-heart-fill text-white text-2xl md:text-3xl"></i>
                </div>
                <div className="hidden md:flex absolute -bottom-4 -left-4 w-12 h-12 md:w-16 md:h-16 items-center justify-center bg-gradient-to-br from-orange-500 to-pink-500 rounded-xl shadow-lg transform -rotate-12">
                  <i className="ri-chat-smile-3-fill text-white text-xl md:text-2xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Access Section */}
      <section className="py-20 relative overflow-hidden" style={{ backgroundColor: '#d4edeb' }}>
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/827597bb-d4b7-4637-a672-488903951106.png)', backgroundSize: '60px 60px' }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div>
              <span className="text-sm font-bold tracking-wider" style={{ color: '#0068b7' }}>ACCESS</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6" style={{ color: '#0068b7' }}>アクセス</h2>
              <div className="space-y-4" style={{ color: '#0068b7' }}>
                <p className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-2xl mt-1" style={{ color: '#0068b7' }}></i>
                  <span>
                    <strong className="block mb-1" style={{ color: '#0068b7' }}>住所</strong>
                    〒146-0091 東京都大田区鵜の木2-5-5<br />
                    イーグル鵜の木原田ビル1階G号
                  </span>
                </p>
                <p className="flex items-start gap-3">
                  <i className="ri-train-line text-2xl mt-1" style={{ color: '#0068b7' }}></i>
                  <span>
                    <strong className="block mb-1" style={{ color: '#0068b7' }}>最寄り駅</strong>
                    東急多摩川線 鵜の木駅より<strong style={{ color: '#0068b7' }}>徒歩30秒</strong>
                  </span>
                </p>
                <p className="flex items-start gap-3">
                  <i className="ri-phone-line text-2xl mt-1" style={{ color: '#0068b7' }}></i>
                  <span>
                    <strong className="block mb-1" style={{ color: '#0068b7' }}>電話番号</strong>
                    <a href="tel:03-6715-0369" className="hover:opacity-80 transition-opacity cursor-pointer" style={{ color: '#0068b7' }}>
                      03-6715-0369
                    </a>
                  </span>
                </p>
              </div>
              <Link
                to="/access"
                className="inline-flex items-center gap-2 px-8 py-4 mt-8 rounded-full font-bold text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#0068b7' }}
              >
                <span>詳しいアクセス情報</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.8447890234567!2d139.6786174!3d35.5754191!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185f8c78e8258d%3A0xc7aca39b96b08092!2z44GV44GL44Gq44Gu5pyo!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="さかなの木 地図"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section 
        id="contact" 
        className="py-20 relative"
      >
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#3A3D3F' }}>ご予約・お問い合わせ</h2>
            <p className="text-gray-600 mt-4">お電話またはLINEにてお気軽にお問い合わせください</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <a
              href="tel:03-6715-0369"
              className="group relative flex flex-col items-center justify-center p-10 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10 w-20 h-20 flex items-center justify-center bg-gradient-to-br from-primary to-primary/80 rounded-full mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <i className="ri-phone-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3" style={{ color: '#454545' }}>電話予約</h3>
              <p className="text-3xl font-bold text-primary mb-4 group-hover:scale-105 transition-transform duration-300">03-6715-0369</p>
              <p className="text-sm text-gray-600 text-center leading-relaxed">
                ランチ 11:30-14:00<br />
                ディナー 17:00-22:00(月-木)<br />
                ディナー 17:00-23:00(金土)
              </p>
              <div className="mt-6 px-8 py-3 bg-primary text-white rounded-full font-bold text-sm group-hover:bg-primary/90 transition-all shadow-md group-hover:shadow-lg whitespace-nowrap">
                今すぐ電話する
              </div>
            </a>
            <a
              href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col items-center justify-center p-10 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#06C755]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10 w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#06C755] to-[#05B04D] rounded-full mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <i className="ri-line-fill text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3" style={{ color: '#454545' }}>LINE予約</h3>
              <p className="text-lg text-gray-600 mb-4">公式LINEで簡単予約</p>
              <div className="mt-6 px-10 py-4 bg-gradient-to-r from-[#06C755] to-[#05B04D] text-white rounded-full font-bold text-base shadow-lg group-hover:shadow-xl group-hover:scale-105 transition-all whitespace-nowrap flex items-center gap-2">
                <span>LINEで予約する</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
